import { ButtonAsLinkVariant, ButtonVariant } from '@property.com.au/ui-kit';

export type ApiButtonVariant =
  | 'PRIMARY'
  | 'SECONDARY'
  | 'OUTLINE'
  | 'NAKED'
  | 'LINK_PRIMARY'
  | 'LINK_SECONDARY'
  | 'LINK_INLINE'
  | 'OUTLINE_SECONDARY'
  | 'SELECTED';

export const mapApiButtonVariantToButtonVariant = (
  apiButtonVariant: ApiButtonVariant,
): ButtonVariant | ButtonAsLinkVariant => {
  switch (apiButtonVariant) {
    case 'PRIMARY':
      return 'primary';
    case 'SECONDARY':
      return 'secondary';
    case 'OUTLINE':
      return 'outline';
    case 'NAKED':
      return 'naked';
    case 'LINK_PRIMARY':
      return 'link-primary';
    case 'LINK_SECONDARY':
      return 'link-secondary';
    case 'LINK_INLINE':
      return 'link-inline';
    case 'OUTLINE_SECONDARY':
      return 'outline-secondary';
    case 'SELECTED':
      return 'selected';
    default:
      return 'primary';
  }
};
